module.exports = __webpack_public_path__ + "img/collection-memoireRingsAsWeddingRings.71e6cf9.webp";